module.exports = __webpack_public_path__ + "img/model_zp.0c8fa1a9.png";